module.exports = __webpack_public_path__ + "assets/img/2ee2a2982ac396baab5dd5d90917e3ba.png";